import React from 'react';
import Button from '@mui/material/Button';

export interface ButtonProps {
  id?: string;
  children: React.ReactNode | 'string';
  onClick: () => void;
  className?: string;
  sx?: object;
  variant?: 'text' | 'outlined' | 'contained';
  disabled?: boolean;
  disableTouchRipple?: boolean;
  loading?: boolean;
}

export const ButtonBase: React.FC<ButtonProps> = ({
  id,
  children,
  onClick,
  className,
  sx,
  variant,
  disabled,
  disableTouchRipple,
}) => {
  return (
    <Button
      id={id}
      onClick={onClick}
      className={`max-h-14 sm:max-h-16 ${className}`}
      sx={sx}
      variant={variant}
      disableElevation
      disableTouchRipple={disableTouchRipple}
      disabled={disabled}
    >
      {children}
    </Button>
  );
};
